import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntWinterCerealFertilizerFilter } from "../../../models/filters/winterCerealFertilizerFilter";
import { EntWinterCerealFertilizer } from "../../../models/chemicalization/winterCerealFertilizer";
import { BlobResponse } from "../../../models/report";
import { EntReportPesticidesFilter } from "../../../models/filters/pesticidesFilter";
import { Paths } from "../../../paths";

export const winterCerealFertilizerApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getWinterCerealFertilizerList: builder.query<ResponseDataGet<EntWinterCerealFertilizer>, EntWinterCerealFertilizerFilter>({
	  query: (filter) => ({
		url: `${Paths.chemicalization.winterCerealFertilizer}/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getWinterCerealFertilizerById: builder.query<ResponseDataTest<EntWinterCerealFertilizer>, number>({
	  query: (id) => ({
		url: `${Paths.chemicalization.winterCerealFertilizer}/${ id }`,
		method: 'GET'
	  })
	}),
	addWinterCerealFertilizer: builder.mutation<ResponseDataTest<EntWinterCerealFertilizer>, EntWinterCerealFertilizer>({
	  query: (body) => ({
		url: `${Paths.chemicalization.winterCerealFertilizer}`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editWinterCerealFertilizer: builder.mutation<ResponseDataTest<EntWinterCerealFertilizer>, EntWinterCerealFertilizer>({
	  query: (body,) => ({
		url: `${Paths.chemicalization.winterCerealFertilizer}`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteWinterCerealFertilizer: builder.mutation<ResponseDataTest<EntWinterCerealFertilizer>, number>({
	  query: (id) => ({
		url: `${Paths.chemicalization.winterCerealFertilizer}/${ id }`,
		method: 'DELETE',
	  }),
	}),
	reportWinterCerealFertilizer: builder.mutation<BlobResponse, EntReportPesticidesFilter>({
	  query: (payload) => {
		const { periodStart, periodEnd, language } = payload;

		return {
		  url: `/departments/chemicalization/report/winter-cereal-fertilizer`,
		  method: "POST",
		  params: {
			periodStart,
			periodEnd,
			language
		  },
		  body: JSON.stringify(payload),
		  responseHandler: (response) => response.blob(),
		};
	  },
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddWinterCerealFertilizerMutation,
  useDeleteWinterCerealFertilizerMutation,
  useEditWinterCerealFertilizerMutation,
  useLazyGetWinterCerealFertilizerListQuery,
  useReportWinterCerealFertilizerMutation
} = winterCerealFertilizerApi;
